import IDoctorProfile from "../../interfaces/doctor/IDoctorProfile"
import ApiUtils from "../ApiUtils"
import { AxiosPromise } from "axios"
import { PaginatedResponse } from "../../interfaces/baseInterfaces"
import { IDefaultWorkingHoursRequest, IDefaultWorkingHoursResponse, IUpdateDefaultWorkingHoursRequest } from "../../interfaces/api/ollivander/IDefaultWorkingHour"
import { IOllivanderApis } from "./IOllivanderApis"
import { IFetchConfigRequestParams, IFetchConfigResponse } from "../../interfaces/api/ollivander/IFetchLoggingConfig"
import { IConstituentTemplate } from "../../interfaces/IPdfTemplate"
import { IAgentByAccountEmailResponse } from "../../interfaces/api/ollivander/fetchAgentByAccountEmail"
import { ISearchAgentsByTlResponse } from "../../interfaces/api/ollivander/IAgentsByTL"

// const fetchTemplatesUrl = `${OLLIVANDER_PREFIX}/agents/$doctorId/template?center-id=$centerId&sub-service-type=$doctorType`;
// const fetchConfigUrl = `${OLLIVANDER_PREFIX}/config/getConfig`;
// const updateDoctorDefaultWorkingHoursUrl = `${OLLIVANDER_PREFIX}/agent/$doctorId/shifts`;
// const fetchAgentById = OLLIVANDER_PREFIX + `/agents/$agentId`;
// const fetchAgentsByIds = OLLIVANDER_PREFIX + `/agents/id`;

export const OllivanderUrls = {
	searchAgent: "/agents",
	fetchDoctorDefaultWorkingHours: (doctorId: number, centerId: number) => `/agents/${doctorId}/shifts?center-id=${centerId}`,
	updateDoctorDefaultWorkingHours: (doctorId: number) => `/agent/${doctorId}/shifts`,
	fetchConfigUrl: `/config/getConfig`,
	fetchTemplates: (doctorId: number, centerId: number, doctorType: string) => `/agents/${doctorId}/template?center-id=${centerId}&sub-service-type=${doctorType}`,
	getAgentIdByAccountEmailId: (emailId: string) => `/agents/v2/?emailId=${encodeURIComponent(emailId)}&page-no=0&page-size=5`,
	searchAgentsByTL: (teamLeadId: number) => `/agents/search-by-tl?team-lead-id=${teamLeadId}`,
	fetchAgentById: (agentId: number) => `/agents/${agentId}`,
	fetchAgentsByIds: `/agents/id`,
	bulkFetchAgents: (agentIds: number[]) => `/agents/all/v2?agentIds=${encodeURIComponent(agentIds.join(","))}&agentCentersRequired=false`,
}

export default class OllivanderApis implements IOllivanderApis {
	getServiceUrl = (url: string) => "/ollivander" + url
	fetchTemplates(doctorId: number, centerId: number, doctorType: string): Promise<IConstituentTemplate> {
		return ApiUtils.get(this.getServiceUrl(OllivanderUrls.fetchTemplates(doctorId, centerId, doctorType)))
	}

	fetchLogConfig(doctorId: number): Promise<IFetchConfigResponse> {
		const requestParams: IFetchConfigRequestParams = {
			configName: "OrionVerboseLogs",
			category: "ORION_LOGS",
			searchParams: [
				{
					referenceEntity: "DOCTOR",
					value: doctorId,
				},
			],
		}
		return ApiUtils.put(this.getServiceUrl(OllivanderUrls.fetchConfigUrl), requestParams)
	}
	//
	// fetchFeatueConfigInfo(params: IFeatureConfigRequest): Promise<IFeatureConfigResponse> {
	// 	return ApiUtils.apiPutRequest(fetchConfigUrl, JSON.stringify(params));
	// }
	//
	fetchDoctorDefaultWorkingHours(params: IDefaultWorkingHoursRequest): Promise<IDefaultWorkingHoursResponse[]> {
		const url = this.getServiceUrl(OllivanderUrls.fetchDoctorDefaultWorkingHours(params.doctorId, params.centerId))
		return ApiUtils.get(url)
	}
	//
	updateDoctorDefaultWorkingHours(params: IUpdateDefaultWorkingHoursRequest[], doctorId: number): Promise<IDefaultWorkingHoursResponse[]> {
		const url = this.getServiceUrl(OllivanderUrls.updateDoctorDefaultWorkingHours(doctorId))
		return ApiUtils.post(url, params)
	}

	fetchAgentById = (agentId: string) => {
		return ApiUtils.get(this.getServiceUrl(OllivanderUrls.fetchAgentById(Number(agentId))))
	}

	fetchAgentsByIds = (agentIds: number[]) => {
		return ApiUtils.get(this.getServiceUrl(OllivanderUrls.fetchAgentsByIds) + "?" + ApiUtils.requestToQueryParams({ "agent-ids": agentIds }))
	}

	getDoctorProfile(searchParams: any): Promise<PaginatedResponse<IDoctorProfile>> {
		const url = this.getServiceUrl(`${OllivanderUrls.searchAgent}?${ApiUtils.requestToQueryParams(searchParams)}`)
		return ApiUtils.get(url)
	}

	getAgentByAccountEmailId(emailId: string): Promise<IAgentByAccountEmailResponse> {
		const url = this.getServiceUrl(OllivanderUrls.getAgentIdByAccountEmailId(emailId))
		return ApiUtils.get(url)
	}

	searchAgentsByTl = (teamLeadId: number): Promise<ISearchAgentsByTlResponse> => {
		const url = this.getServiceUrl(OllivanderUrls.searchAgentsByTL(teamLeadId))
		return ApiUtils.get(url)
	}

	bulkFetchAgents(agentIds: number[]): Promise<IDoctorProfile[]> {
		const url = this.getServiceUrl(OllivanderUrls.bulkFetchAgents(agentIds))
		return ApiUtils.get(url)
	}
}
